import Vue from 'vue'
import VueRouter from 'vue-router'
import ProjectTemplate from '@/components/ProjectTemplate'
import ChildView from '@/components/ChildView'
import store from '@/store/store'
import { actionTypes } from '@/store/store.type'
import AppService from '@/services/app.service'
import lodash from 'lodash'
import UserService from '@/services/user.service'
import AuthService from '@/services/auth.service'
import $const from '@/utils/const'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        meta: {
            requiresAuth: true
        },
        component: ProjectTemplate,
        children: [
            {
                path: '',
                name: 'Dashboard',
                component: () => import('@/views/Dashboard/Dashboard')
            }
        ]
    },
    {
        path: '/authentication',
        component: ChildView,
        children: [
            {
                path: '',
                name: 'authentication-options',
                component: () => import('@/views/Authentication/AuthenticationOptions.vue')
            },
            {
                path: 'failed',
                name: 'authentication-failed',
                component: () => import('@/views/Authentication/AuthenticationFailed.vue')
            },
            {
                path: 'self',
                name: 'authentication-self',
                component: () => import('@/views/Authentication/AuthenticationSelf.vue')
            },
            {
                path: 'fpt-id',
                component: ChildView,
                children: [
                    {
                        path: '',
                        name: 'authentication-fpt-id',
                        component: () => import('@/views/Authentication/AuthenticationFptId.vue')
                    },
                    {
                        path: 'success',
                        name: 'authentication-fpt-id-success',
                        component: () => import('@/views/Authentication/AuthenticationFptIdSuccess.vue')
                    }
                ]
            }
        ]
    },
    {
        path: '/',
        meta: {
            requiresAuth: true
        },
        component: ProjectTemplate,
        children: [
            {
                path: 'bots/:botCode/',
                redirect: 'bots/:botCode/scenario'
            },
            {
                path: 'bots/:botCode/scenario',
                name: 'Scenario',
                component: () => import('@/views/Scenario/Scenario')
            },
            {
                path: 'bots/:botCode/debugger',
                name: 'Debugger',
                component: () => import('@/views/Debugger/Debugger')
            }
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach(async (to, from, next) => {
    let guard = true
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!store.getters.token) {
            guard = false
            const providerStr = to.query.provider ? to.query.provider : process.env.VUE_APP_DEFAULT_OPEN_ID
            AuthService.getProvider(providerStr).then(provider => {
                sessionStorage.setItem($const.sessionStorageKey.provider, JSON.stringify(provider))
                store.dispatch(actionTypes.user.SIGN_IN)
            })
        }
    }
    if (!guard) {
        return
    }
    if (to.matched.some(record => Array.isArray(record.meta.roles) && record.meta.roles.length > 0)) {
        let userRoles = null
        if (store.state.user.isProfileLoaded) {
            userRoles = store.state.user.profile.roles
        } else {
            try {
                let profileRes = await UserService.getProfile()
                userRoles = profileRes.data.roles
            } catch (e) {
                router.push('/')
            }
        }
        if (Array.isArray(userRoles)) {
            for (let record of to.matched) {
                let routeRoles = record.meta.roles
                if (Array.isArray(routeRoles) && routeRoles.length > 0) {
                    if (lodash.difference(userRoles, routeRoles).length === userRoles.length) {
                        guard = false
                        router.push({ name: 'AccessDenied' })
                        break
                    }
                }
            }
        } else {
            guard = false
        }
    }

    if (guard) {
        next()
    } else {
        AppService.toastError('access denied')
    }
})

export default router
